import ListIcon from '@mui/icons-material/List';
import DefaultIcon from '@mui/icons-material/ViewList';
import { useState } from 'react';
import { DashboardMenuItem, Menu, MenuItemLink, MenuProps, ResourceDefinitions, useResourceDefinitions, useTranslate } from 'react-admin';
import SubMenu from './SubMenu';

interface ProjectMenuSubProps {
  alias: string,
  items: Array<ResourceDefinitions>,
  // onMenuClick: () => {},
}

const ProjectMenuSub = ({ alias, items }: ProjectMenuSubProps) => {
  // const [open] = useSidebarState();
  const [isOpen, setIsOpen] = useState(true);
  const translate = useTranslate();

  return (
    <SubMenu
      // key={key}
      handleToggle={() => setIsOpen(o => !o)}
      isOpen={isOpen}
      name={`menu.${alias}`}
      icon={<ListIcon />}
      dense={true}
    >
      {items.map((resource: any) =>
        resource.hasList
          ? <MenuItemLink
            key={resource.name}
            to={`/${resource.name}${resource.options && resource.options.recordId ? ('/' + resource.options.recordId) : ''}`}
            primaryText={translate(`resources.${resource.name}.name`)}
            leftIcon={
              resource.icon ? <resource.icon /> : <DefaultIcon />
            }
            // onClick={onMenuClick}
            // sidebarIsOpen={open}
            dense={true}
          />
          : null)}
    </SubMenu>
  )
}

const ProjectMenu = (props: MenuProps) => {
  const resourcesDefinitions = useResourceDefinitions();
  const resources = Object.keys(resourcesDefinitions).map(name => resourcesDefinitions[name]);
  // const [open] = useSidebarState();

  let resourcesByGroup: { [key: string]: Array<ResourceDefinitions> } = resources.reduce((r, a) => {
    let group = a.options ? a.options.group : 'misc';
    r[group] = r[group] || [];
    r[group].push(a);
    return r;
  }, Object.create(null))

  console.log("ProjectMenu", resources, resourcesByGroup);
  return (
    <Menu {...props}>
      <DashboardMenuItem />
      {/* <MenuItemLink key={'school-calendar'} to={`/ui/school-calendar`} primaryText={`Calendar`} leftIcon={<CalendarTodayIcon />} sidebarIsOpen={open} /> */}
      {/* <MenuItemLink key={'admin-management'} to={`/ui/admin-management`} primaryText={`Admin`} leftIcon={<SupervisedUserCircleIcon />} sidebarIsOpen={open} /> */}
      {/* <MenuItemLink key={'system-config'} to={`/ui/system-config`} primaryText={`System`} leftIcon={<SettingsIcon />} sidebarIsOpen={open} /> */}
      <hr />
      {Object.entries(resourcesByGroup).map(([key, items], index) =>
        <ProjectMenuSub key={key} alias={key} items={items} />
      )}
      {/* {resources.map(resource =>
        resource.hasList
          ? <MenuItemLink
            key={resource.name}
            to={`/${resource.name}`}
            primaryText={
              (resource.options && resource.options.label) ||
              `_${resource.name}`
            }
            leftIcon={
              resource.icon ? <resource.icon /> : <DefaultIcon />
            }
            onClick={props.onMenuClick}
            sidebarIsOpen={open}
          />
          : null)} */}
    </Menu>
  );
}

export default ProjectMenu;
